import React from "react";

import { faCircleCheck, faCircleXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Text, TextDate } from "@performyard/py-components";
import { ScimLogModelFrontend } from "@performyard/service-contracts";

import Typography from "../../../../../components/Text";

import { getColor } from "../../../../../utils/getColor";

import css from "../ScimLog.module.scss";

interface FormattedLogDetailsProps {
	scimLog: ScimLogModelFrontend;
}

const icons = {
	error: faCircleXmark,
	success: faCircleCheck,
};

const colors: {
	[key: string]: ReturnType<typeof getColor>;
} = {
	error: getColor("red", 4),
	success: getColor("green", 5),
};

const FormattedLogDetails = ({ scimLog }: FormattedLogDetailsProps) => {
	// Display log with error message and icon when status is failed
	if (scimLog.status !== "completed") {
		return (
			<div className={css.logItem}>
				<FontAwesomeIcon icon={icons.error} color={colors.error} size="sm" />
				<Typography size="paragraph-3" weight="semi-bold">
					{scimLog.errorMessage || "An unknown error occurred"}
				</Typography>
			</div>
		);
	}

	// When status is completed, show list of details with success icons and formatted message
	return scimLog.updates.map((update) => {
		return (
			<div key={update.field_id} className={css.logItem}>
				<FontAwesomeIcon icon={icons.success} color={colors.success} size="sm" />
				<div className={css.logMessage}>
					<Typography size="paragraph-3" weight="semi-bold">{`${update.name}: `}</Typography>
					{update.value instanceof Date ? (
						<TextDate
							dateSize="medium"
							hasTime={true}
							hasDelimiter={true}
							date={update.value}
							size="paragraph-3"
							weight="regular"
						/>
					) : update.value && typeof update.value === "string" ? (
						<Text
							wrap={false}
							size="paragraph-3"
							weight="regular"
							dangerouslySetClassName="py-text-truncate min-w-0 max-w-[250px]"
						>
							{update.value}
						</Text>
					) : (
						""
					)}
				</div>
			</div>
		);
	});
};

export default FormattedLogDetails;
